import React from 'react';
import PersonalTaskForm from '../PersonalTaskForm';

const AddPersonalTaskForm = (props) => {
    return <PersonalTaskForm {...props} />;
};

export default AddPersonalTaskForm;
